import "./_detailOperationCommerciale.scss";

import {ReactElement, useEffect, useState} from "react";
import {useNavigate, useParams} from "react-router-dom";

import {
  FetchOperationCommerciale,
  FetchOperationCommercialeCommande,
} from "@/api/operationCommerciale";
import iconBack from "@/assets/massification/iconPrevious.svg";
import Button from "@/components/Button/Button";
import Loader from "@/components/Loader/loader";
import DetailOpCo from "@/components/OperationCommerciale/DetailOperationCommerciale/DetailOperationCommerciale";
import Section from "@/components/Section/Section";
import {HookFormContextProvider} from "@/context/HookFormContext";
import {convertCommandeToFormOperationCommercial} from "@/function/operationCommercialeToole";
import {
  CommandeAPI,
  FormOperationsCommercialesMap,
  OperationCommerciale,
} from "@/ts/interface/operationCommerciale";

function DetailOperationCommerciale(): ReactElement {
  const [isLoad, setIsLoad] = useState<boolean>(true);
  const [operationsCommerciale, setOperationCommerciale] =
    useState<OperationCommerciale | null>(null);
  const [commandes, setCommandes] = useState<CommandeAPI[] | null>(null);
  const [defaultFormValue, setDefaultFormValue] = useState<
    FormOperationsCommercialesMap | undefined
  >(undefined);
  const {id = ""} = useParams();
  const navigate = useNavigate();
  useEffect(() => {
    const getOperation = async (): Promise<void> => {
      const reponse = await FetchOperationCommerciale(id);
      if (reponse) {
        const operation_commerciale = reponse;
        setOperationCommerciale(operation_commerciale);
      }
    };
    const getCommandes = async (): Promise<void> => {
      const reponse = await FetchOperationCommercialeCommande([
        `operation=${id}`,
      ]);
      if (reponse?.commandes) {
        const commandes_operation = reponse?.commandes;
        setCommandes(commandes_operation);
      }
    };
    getCommandes();
    getOperation();
  }, []);
  useEffect(() => {
    const getDefaultValue = async (): Promise<void> => {
      if (operationsCommerciale && commandes !== null) {
        const indexSaveCommande = commandes?.findIndex(
          commande => commande.statut === "Enregistrée",
        );

        if (
          operationsCommerciale &&
          indexSaveCommande > -1 &&
          commandes?.[indexSaveCommande]
        ) {
          const newDefaultValue =
            await convertCommandeToFormOperationCommercial(
              commandes[indexSaveCommande],
            );

          setDefaultFormValue(newDefaultValue);
        }
        setIsLoad(false);
      }
    };
    getDefaultValue();
  }, [commandes, operationsCommerciale]);
  console.log("defaultFormValue", commandes !== null && commandes.length > 0);
  const hasRefuse = commandes?.find(commande => commande.statut === "Refusée");
  return (
    <Section id="detail_operation">
      {isLoad ? (
        <Loader />
      ) : (
        <>
          <Button
            label="Retour"
            variant="secondary"
            icon={iconBack}
            className="returnButton"
            onClick={() =>
              navigate({
                pathname: "/co-deals",
                search: "",
              })
            }
          />
          <HookFormContextProvider defaultValues={defaultFormValue}>
            <DetailOpCo
              operation={operationsCommerciale}
              hasSaveCommande={
                defaultFormValue?.commande_id &&
                defaultFormValue?.commande_id > 0
                  ? true
                  : false
              }
              hasCommande={commandes !== null && commandes.length > 0}
              hasRefuse={hasRefuse ? true : false}
            />
          </HookFormContextProvider>
        </>
      )}
    </Section>
  );
}

export default DetailOperationCommerciale;
